
import NavbarDesktop from './navbar-desktop.vue'
import NavbarMobile from './navbar-mobile.vue'

export default {
  components: {
    NavbarDesktop,
    NavbarMobile
  },
  methods: {
    toggleBurger() {
      this.$refs.navbar?.toggleBurger()  
    }
  }
}

